import(/* webpackMode: "eager", webpackExports: ["CollectionsClient"] */ "/vercel/path0/app/collections/CollectionsClient.tsx");
